import { ActionTree } from 'vuex';
import { CampaignState } from './CampaignTypes';
import { RootState } from '@/app/shared/store/RootState';

export const actions: ActionTree<CampaignState, RootState> = {

};
